import axios from 'axios';

//const API_BASE_URL = 'http://localhost:8001/';
const API_BASE_URL = 'https://api.totalpe.io/identity/';

const deactivationApi = {
  requestDeactivation: async (data) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/users/deactivate`,
        {
          name: data.name,
          phone: data.phone,
          store_name: data.store_name
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default deactivationApi;
